export default function (_this) {
  return {
    read () {
      return new Promise(function (resolve) {
        _this.getRef('models')
          .once('value', (snapshot) => {
            ///.console.log('get dashboard model on first load')
            resolve(snapshot.val())
          }, (err) => {
            console.error(err)
          })
      })
    },
    setDashboardModel (pathToModel, val) {
      const p = pathToModel.replace(/\./g, '/')

      return new Promise((resolve, reject) => {
        _this.getRef('models').child(p).set(val, (err) => {
          if (err) {
            reject(err)
          } else {
            resolve()
          }
        })
      })
    },
    updateDashboardModel (pathToModel, val) {
      const p = pathToModel.replace(/\./g, '/')

      return new Promise((resolve, reject) => {
        _this.getRef('models').child(p).update(val, (err) => {
          if (err) {
            reject(err)
          } else {
            resolve()
          }
        })
      })
    },
    async addDashboardModel (pathToModel, val) {
      const p = pathToModel.replace(/\./g, '/')

      await new Promise((resolve, reject) => {
        _this.getRef('models').child(p).push(val, (err) => {
          if (err) reject()
          else resolve()
        })
      })
    }
  }
}
